import { createLabeledMessages } from '@gef-ui/localization/messageUtils';

/* eslint-disable max-len */

// todo - clean up localizations

const titles = {
	mainTitle: 'Požadavek na obchodníka',
	taskDetail: 'Detail úkolu',
	psInfo: 'Informace o PS',
	clientInformation: 'Údaje o klientovi',
	note: 'Poznámka',
	attachments: 'Přiložení příloh',
	documents: 'Přiložení ID dokumentu',
	solverSetup: 'Nastavení řešitele',
	taskAdditionalInfo: 'Doplnění údajů',
};

const buttons = {
	createTask: 'Vytvořit úkol',
	submitDocument: 'Přiložit',
};

const warnings = {
	noPSNumber: 'Číslo PS je vyžadováno.',
	noSolverMandatoryField: 'Alespoň jedno ze zvýrazněných kritérií musí být vyplněno.',
	noEmailOrPhoneValid: 'Vyplňte Telefon nebo E-mail klienta',
	nonUniqueSolver: 'K zadaným informacím o řešiteli neodpovídá právě jeden uživatel, prosím upřesněte podmínky.',
	noName: 'Vyplňte Příjmení a Jméno nebo Název.',
	documentNotFound: 'Dokument nebyl podle ID v Digitálním archivu nalezen',
	backOfficeWithGPPolicyNoAndAttachments: 'Úkol Backoffice na smlouvu z bývalé Generali nemůže obsahovat přílohy.',
};

const infoMessages = {
	taskIsBeingCreated: 'Vytváří se úkol',
};

const others = {
	taskTypeValue: 'Požadavek na obchodníka',
};

const merge = {
	...titles,
	...buttons,
	...warnings,
	...infoMessages,
	...others,
};

export default Object.assign({}, merge, createLabeledMessages(merge));
